import { Registry } from '@lightningjs/sdk';
import { GlobalSettingsKeys } from '../../../api/models/GlobalSettingsKeys';
import { Backend } from '../../../api/Backend';
import { StreamInfo } from '../streamInfo/StreamInfo';

export class BookmarkHandler {
  private _backend: Backend;
  private _streamInfo: StreamInfo;
  private _bookmarkTimer: number | undefined;
  constructor(backend: Backend, streamInfo: StreamInfo) {
    this._backend = backend;
    this._streamInfo = streamInfo;
  }

  start() {
    this._startBookmarkTimer();
  }

  stop() {
    this._stopBookmarkTimer();
    this._updateBookmarkTimes();
  }

  _startBookmarkTimer() {
    this._stopBookmarkTimer();
    const timeInterval = this._backend.globalSettings.numberValue(GlobalSettingsKeys.playerBookmarkTime) || 300000;
    this._bookmarkTimer = Registry.setInterval(() => this._updateBookmarkTimes(), timeInterval);
  }

  _stopBookmarkTimer() {
    if (this._bookmarkTimer) {
      Registry.clearInterval(this._bookmarkTimer);
      this._bookmarkTimer = undefined;
    }
  }

  _updateBookmarkTimes() {
    if (!this._backend.playerController.playerService.playerReady) {
      return;
    }
    const playTimes = this._streamInfo.convertPlayTimes(
      this._backend.playerController.playerService.absolutePosition,
      this._backend.playerController.playerService.duration,
      this._backend.playerController.playerService.isLive
    );

    const allowBookMark = this._streamInfo.updateBookmark(playTimes.position, playTimes.duration);
    if (!allowBookMark) return;

    const bookmarkId = this._streamInfo.bookmark?.id;
    const bookmarkValue = this._streamInfo.bookmark?.value;
    if (bookmarkId && bookmarkValue) {
      bookmarkId.profileId = this._backend.deviceProfile?.id;

      this._backend.cachedBookmarkApi.update(this._backend, bookmarkId, bookmarkValue).then();
    }
  }
}
